import React, { Component } from 'react'
import {
  Modal,
  ModalBackground,
  Delete,
  ModalCard,
  ModalCardBody,
  ModalCardFooter,
  ModalCardHeader,
  ModalCardTitle,
  Button,
} from 'bloomer'
import { Mutation } from 'react-apollo'
import { gql } from 'apollo-boost'

const DELETE_ROOM = gql`
  mutation ($roomId: UUID!) {
    deleteRoom(roomId: $roomId) {
      room { id }
    }
  }
`

export default class DeleteRoomModal extends Component {
  state = {
    error: null
  }

  handleClose = (evt) => {
    this.setState(() => ({
      error: null
    }))

    this.props.handleClose(evt)
  }

  handleSubmit = async (deleteRoomMutation, evt) => {
    evt.preventDefault()

    const { room } = this.props

    try {
      await deleteRoomMutation({
        variables: {
          roomId: room.id
        }
      })

      this.setState(() => ({
        error: null
      }))

      this.props.handleClose(evt)
      this.props.refetch()
    } catch (e) {
      this.setState(() => ({
        error: 'Ocorreu um erro na comunicação com servidor'
      }))
      console.error(e)
    }
  }

  render() {
    const { isActive, room } = this.props

    return (
      <Modal isActive={isActive}>
        <ModalBackground onClick={this.handleClose}/>
        <Mutation mutation={DELETE_ROOM}>
          {(deleteRoom, {loading}) => (
            <ModalCard tag="form" onSubmit={this.handleSubmit.bind(this, deleteRoom)}>
              <ModalCardHeader>
                <ModalCardTitle>Excluir cômodo</ModalCardTitle>
                <Delete onClick={this.handleClose} />
              </ModalCardHeader>
              <ModalCardBody>
                <p>
                  Você tem certeza que deseja excluir o cômodo <strong>{room.name}</strong>?
                </p>
              </ModalCardBody>
              <ModalCardFooter>
                <Button type="submit" isLoading={loading} isColor="danger">Excluir</Button>
                <Button onClick={this.handleClose}>Cancelar</Button>
              </ModalCardFooter>
            </ModalCard>
          )}
        </Mutation>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/DashboardPage/modals/DeleteRoomModal.js